export default {
  pt: {
    UPDATED_AT: 'Atualizado em',
    OFFER_END_IN: 'A oferta termina em',
    I_WANT_IT: 'Eu quero',
    REMOVE: 'Remover',
    SHARE: 'Compartilhar',
    SHARE_FREE_COURSE: 'Compartilhe com seus amigos',
    ADD: 'Adicionar',
    GIFT: 'Presentear',
    REQUIREMENTS_TITLE: 'O que preciso aprender a {{friendlyTitle}}?',
    REQUIREMENTS_TITLE_2: 'O que preciso?',
    ABOUT_TITLE: 'Sobre o que é este curso?',
    SHOW_CONTENT: 'Mostrar conteúdo',
    HIDE_CONTENT: 'Ocultar conteúdo',
    LESSONS_SECTION_TITLE: 'Agenda do curso',
    LEVEL_REQUIREMENTS_TITLE: 'Curso de nível {{level}}',
    SHOW_ALL_LESSONS: 'Mostrar todo o temário',
    HIDE_ALL_LESSONS: 'Ocultar todo o temário',
    FEATURED_REVIEW_TITLE: 'Revisão em destaque',
    REVIEWS_TITLE: 'Avaliações',
    TOTAL_SCORE: 'Média total',
    LOAD_MORE_REVIEWS: 'Mostrar mais comentários',
    WATCH_TRAILER: 'Assista ao trailer',
    BUY_NOW: 'Comprar agora',
    ENROLL_NOW: 'Inscreva-se agora',
    YEARLY: 'Ao ano',
    BECOME_PREMIUM: 'Assine Premium',
    PREMIUM_COPY: 'Faça parte da nossa comunidade Premium',
    BUY_FRECUENTLY: 'Comprou com frequência',
    BEST_SELLER: 'Mais vendido',
    NEW: 'Novo',
    STUDENTS: 'Estudiantes',
    FAQ_TITLE: 'Perguntas frequentes',
    FAQ_QUESTION1_TITLE: 'Eu tenho acesso ilimitado às aulas?',
    FAQ_QUESTION1_TEXT:
      'Sim! Depois de se inscrever no curso, você poderá ter acesso ilimitado às aulas.O curso permanece em sua conta de Crehana para sempre.',
    FAQ_QUESTION1_TEXT_PAY:
      'Sim! Depois de fazer a compra, você poderá acessar as aulas quando e onde quiser. O curso permanece em sua conta de Crehana para sempre. :)',
    FAQ_QUESTION2_TITLE: 'Quando o curso começa?',
    FAQ_QUESTION2_TEXT:
      'Todo o conteúdo é 100% online, com aulas pré-gravadas às quais você terá acesso ilimitado. Você pode começar e desenvolvê-lo no seu próprio ritmo!',
    FAQ_QUESTION2_TEXT_PAY:
      'Todo o conteúdo é 100% on-line, com aulas pré-gravadas às quais você terá acesso após a compra do curso. Você pode começar e desenvolvê-lo no seu próprio ritmo!',
    FAQ_QUESTION3_TITLE: 'Os cursos gratuitos são certificados?',
    FAQ_QUESTION3_TITLE_PAY: 'Como obtenho o diploma do curso?',
    FAQ_QUESTION3_TEXT:
      'Para obter um diploma, você deve se registrar para um curso pago. Você pode rever o nosso catálogo',
    FAQ_QUESTION3_TEXT_PAY:
      'Depois de concluir o curso, você deve desenvolver o projeto final e publicá-lo com a comunidade a partir da seção "Seu projeto final". Os mentores do curso e da equipe Crehana irão revisá-lo e se tudo correr bem, você receberá o diploma para baixá-lo de seu painel de alunos.',
    SEO_TITLE: 'Curso online de',
    SHOW_MORE: 'Ver mais',
    SHOW_LESS: 'Veja menos',
    ACHIEVEMENT_TITLE: 'O que você aprenderá neste curso online de ',
    INFO_SECTION_TITLE: 'Informação do curso',
    TOTAL_LESSONS_TEXT: ' aulas de acesso ilimitado',
    TOTAL_DURATION: 'Duração:',
    TOTAL_ATTACHMENTS_TEXT: ' Arquivos adjuntos',
    CERTIFIES_TEXT: 'Obtenha a certificação quando terminar',
    PROJECTS_TITLE: 'Projetos de Alunos',
    TRY_COURSE: '¡Prove grátis!',
    TEMPORAL_ACCESS: 'Acceso gratuito por 24hrs!',
    PREMIUM_ACCCES: 'ACCESO PREMIUM',
    FREE_SUBSCRIPTION: 'Registre-se gratuitamente!',
    SUBSCRIBE_NOW: 'INSCREVA-SE AGORA!',
    TURN_PREMIUM: 'Torne-se Premium',
    REMOVING: 'Removendo...',
    ADDED: 'Agregado',
    ADDING: 'Adicionando',
    ADD_TO_CART: 'Adicionar ao carrinho',
    SHARE_DIALOG_TITLE: 'Recomende este curso para seus amigos',
    GO_TO_COURSE: 'Vá para o curso',
    VALID_ONLY: '*Válido por 24 horas apenas para novos usuários',
    FREE_TRIAL: 'Prove grátis',
  },
};
